var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col rounded bg-pure-white p-4 lg:p-5" },
    [
      !_vm.editOpened
        ? _c(
            "div",
            { staticClass: "mb-4" },
            [
              !_vm.comment.type
                ? _c("BlTextBody2", {
                    staticClass: "text-slate-1000 whitespace-pre-line",
                    attrs: { text: _vm.comment.body }
                  })
                : _c("div", { staticClass: "flex flex-col gap-4" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-1" },
                      [
                        _c("BlTextBody2", { attrs: { text: "Antecedent" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000 whitespace-pre-line",
                          attrs: { text: _vm.comment.antecedent || "-" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-1" },
                      [
                        _c("BlTextBody2", { attrs: { text: "Behavior" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000 whitespace-pre-line",
                          attrs: { text: _vm.comment.behavior || "-" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-1" },
                      [
                        _c("BlTextBody2", { attrs: { text: "Consequence" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000 whitespace-pre-line",
                          attrs: { text: _vm.comment.consequence || "-" }
                        })
                      ],
                      1
                    )
                  ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mb-4" },
            [
              !_vm.comment.type
                ? _c("BlInputText", {
                    attrs: { input: _vm.bodyInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _c(
                    "div",
                    { staticClass: "flex flex-col gap-4" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.antecedentInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.behaviorInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.consequenceInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
      _vm._v(" "),
      _vm.comment.target_name
        ? _c("BlTextBody2", {
            staticClass: "whitespace-pre-line mb-2",
            attrs: { text: _vm.comment.target_name }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.editOpened
        ? _c(
            "div",
            {
              staticClass:
                "pt-2 flex items-center justify-between gap-2 border-t border-slate-400"
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2 truncate" },
                [
                  !_vm.comment.measurement_id
                    ? _c(
                        "div",
                        [
                          !_vm.comment.user_name
                            ? _c("BlTextBody2", {
                                staticClass: "italic truncate",
                                attrs: {
                                  title: "Deleted user",
                                  text: "Deleted user"
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "h-8 px-2 flex items-center rounded bg-success-100 lg:flex-shrink-0 border border-success-100 lg:max-w-40 truncate"
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-success truncate",
                                    attrs: {
                                      title: _vm.comment.user_name,
                                      text: _vm.comment.user_name
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.viewMode === "desktop"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "h-8 px-2 flex items-center gap-2 rounded bg-slate-200 flex-shrink-0 border border-slate-200"
                        },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text: _vm.displayDate(
                                _vm.comment.updated_at,
                                "DD/MM/YYYY"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "h-2 w-2 flex-shrink-0 rounded-full bg-slate-500"
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: _vm.displayDate(
                                _vm.comment.updated_at,
                                "HH:mm"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.comment.is_edited && _vm.viewMode === "desktop"
                    ? _c("BlTextBody2", { attrs: { text: "Edited" } })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.comment.user_id === _vm.currentUser.id && !_vm.disabledAction
                ? _c(
                    "div",
                    { staticClass: "flex items-center gap-2 flex-shrink-0" },
                    [
                      !_vm.comment.target_name
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "outlined-error",
                              dense: "",
                              icon: "delete",
                              label: "Delete"
                            },
                            on: {
                              clicked: function($event) {
                                _vm.deleteOpened = true
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.comment.target_name
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "outlined",
                              dense: "",
                              icon: "edit",
                              label: "Edit"
                            },
                            on: { clicked: _vm.openEdit }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.comment.target_name
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "outlined",
                              dense: "",
                              icon: "edit",
                              label: "Edit target comment"
                            },
                            on: { clicked: _vm.openEditCommentTarget }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "pt-2 flex items-center justify-end border-t border-slate-400"
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        _vm.editOpened = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.comment.target_name
                    ? _c("BlInputButton", {
                        attrs: {
                          label: "Update",
                          dense: "",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.editLoading
                        },
                        on: { clicked: _vm.onUpdate }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.comment.target_name
                    ? _c("BlInputButton", {
                        attrs: {
                          label: "Update target comment",
                          dense: "",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.editLoading
                        },
                        on: { clicked: _vm.onUpdateCommentTarget }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete comment",
              description:
                "You are about to delete the comment. Are you sure you want to proceed? This action is irreversible.",
              label: "Delete",
              type: "error",
              empty: "",
              disabled: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onDelete
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c2a6b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c2a6b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/comment/Item.vue
// module id = null
// module chunks = 